import { FilterFilled, PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation, useParams } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Col, Dropdown, Input, Menu, Row, Select, Space, Tooltip } from 'antd';
import { APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { setFilterKr } from 'app/entities/filters/filters.reducer';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import TableComponent from 'app/shared/component/table/table';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { quarterMapping } from 'app/shared/util/help';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import KRUpdate from '../form/kr-update';
import ReportQualitativeResultView from '../form/report/view/reportQualitativeResult';
import ReportQuantitativeResultView from '../form/report/view/reportQuantitativeResult';
import { deleteEntity, getEntitiesByMonth, getEntitiesByQuarter, getEntitiesByYears } from '../kr.reducer';
import { columnsMonth, columnsQuarter, columnsYear, commonColumns } from './config';
import { displayPercent } from 'app/shared/util/percent';

const { Search } = Input;

export const KR = () => {
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();
  const { id } = useParams();
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const krList = useAppSelector(state => state.kr.entities);
  const totalItems = useAppSelector(state => state.kr.totalItems);
  const isLoading = useAppSelector(state => state.kr.loading);
  const planPeriodList = useAppSelector(state => state.planPeriod.entities);
  const filtersObjective = useAppSelector(state => state.filters.objective);
  const filtersKr = useAppSelector(state => state.filters.kr);

  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState(false);
  const [idDeletedKr, setIdDeletedKr] = useState(null);
  const [checkedList, setCheckedList] = useState<string[]>(['action']);
  const [filters, setFilter] = useState<any>();

  const [searchText, setSearchText] = useState();
  const [krSelected, setKrSelected] = useState(null);
  const [columnConfig, setColumnConfig] = useState<any[]>([]);
  const [isShowModalQuantitativeView, setShowModalQuantitativeView] = useState(false);
  const [isShowModalQualitativeView, setShowModalQualitativeView] = useState(false);
  const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);

  const dropDownKr = [
    {
      key: '2',
      label: 'Danh sách kết quả thực hiện',
      onclick: item => handleViewResult(item),
      show: true, //isAdmin || krPermissions.UpdateWeight,
    },
  ];

  useEffect(() => {
    initial();
  }, []);

  useEffect(() => {
    setCheckedList([...createColumns().map(x => x.key)]);
  }, [filters]);

  useEffect(() => {
    if (filtersKr) {
      setFilter(filtersKr);
    } else setFilter(filtersObjective);
  }, [filtersKr, filtersObjective]);

  useEffect(() => {
    getAllEntities();
  }, [paginationState, filters]);

  useEffect(() => {
    const columns = createColumns()
    setColumnConfig(columns);
  }, [checkedList, filters]);

  const initial = () => {
    dispatch(getPlanPeriods({}));
  };

  const CustomMenu = ({ value }) => (
    <Menu>
      {dropDownKr.map(
        item =>
          item.show && (
            <Menu.Item key={item.key} onClick={() => item.onclick(value)}>
              {item.label}
            </Menu.Item>
          ),
      )}
    </Menu>
  );

  const ActionColumn = ({ item }) => (
    <div className="action">
      <span className="action-edit">
        {item.editable &&
          <Tooltip title="Sửa">
            <FontAwesomeIcon
              onClick={() => {
                handleEditKr(item);
              }}
              icon="pencil-alt"
            />
          </Tooltip>
        }
      </span>
      <span className="action-delete">
        {item.deleteable &&
          <Tooltip title="Xóa">
            <FontAwesomeIcon onClick={() => handleWarningDeleteItem(item.id)} icon="trash" />
          </Tooltip>
        }
      </span>
    </div>
  );

  const getMonthFromFilters = date => dayjs(date).month() + 1; // Adjust for zero-indexed month

  const addColumnsForQuarter = (column, startMonth, endMonth, columnsAdditional, type) => {
    Object.entries(quarterMapping).forEach(([__, { minMonth, maxMonth, title }]) => {
      if (startMonth >= minMonth && endMonth <= maxMonth) {
        type === PlantPeriodType.Quarter
          ? column.push(
            ...commonColumns,
            {
              title: 'KR năm',
              key: 'purpose',
              fixed: 'left',
              width: 200,
              dataIndex: 'yearPurpose',
            },
            {
              title,
              key: 'quarterPurpose',
              dataIndex: 'quarterPurpose',
              width: 200,
            },
            {
              title: `Tỷ trọng ${title}`,
              key: 'contribution',
              dataIndex: 'contribution',
              width: 100,
              render(item) {
                if (item) {
                  if (Number.isInteger(displayPercent(item ?? 0))) return `${displayPercent(item ?? 0)}%`;
                  return `${displayPercent(item ?? 0).toFixed(2)}%`;
                }
              },
            },
            ...columnsAdditional,
          )
          : column.push(
            ...commonColumns,
            {
              title: 'KR năm',
              key: 'purpose',
              fixed: 'left',
              width: 200,
              dataIndex: 'yearPurpose',
            },
            {
              title, key: 'quarterPurpose',
              width: 200, dataIndex: 'quarterPurpose'
            },
            ...columnsAdditional,
          );
      }
    });
  };

  const addMonthSpecificColumn = (startMonth, index) => ({
    title: `Tháng ${startMonth}`,
    key: index,
    width: 200,
    dataIndex: index,
  });

  const addContributeMonthSpecificColumn = startMonth => ({
    title: `Tỷ trọng Tháng ${startMonth}`,
    key: 'contribution',
    width: 100,
    dataIndex: 'contribution',
    render(item) {
      if (item) {
        if (Number.isInteger(displayPercent(item ?? 0))) return `${displayPercent(item ?? 0)}%`;
        return `${displayPercent(item ?? 0).toFixed(2)}%`;
      }
    },
  });

  const handleColumnsBasedOnPeriodType = (column: any[]) => {
    if (filters?.planPeriodType === PlantPeriodType.Year) {
      column.push(...commonColumns, ...columnsYear);
    } else if (filters?.planPeriodType === PlantPeriodType.Quarter) {
      const startMonth = getMonthFromFilters(filters?.startDate);
      const endMonth = getMonthFromFilters(filters?.dueDate);
      let columnsAdditional = [];
      const indexValues = ['monthOnePurpose', 'monthTwoPurpose', 'monthThreePurpose'];
      for (let index = 0; index <= endMonth - startMonth; index++) {
        columnsAdditional.push(addMonthSpecificColumn(index + startMonth, indexValues[index]));
      }
      columnsAdditional = columnsAdditional.concat(columnsQuarter);
      addColumnsForQuarter(column, startMonth, endMonth, columnsAdditional, filters?.planPeriodType);
    } else if (filters?.planPeriodType === PlantPeriodType.Month) {
      const startMonth = getMonthFromFilters(filters?.startDate);
      const endMonth = getMonthFromFilters(filters?.dueDate);
      addColumnsForQuarter(
        column,
        startMonth,
        endMonth,
        [addMonthSpecificColumn(startMonth, 'monthPurpose'), addContributeMonthSpecificColumn(startMonth), ...columnsMonth],
        filters?.planPeriodType,
      );
    }
  };

  const createColumns = () => {
    const columnDefault: any[] = [{
      key: 'action',
      fixed: 'left',
      width: 50,
      filterDropdown: () => (
        <Checkbox.Group
          className="d-grid gap-3 p-3 overflow-auto height-350 align-items-center"
          value={checkedList}
          options={column.map(x => ({
            label: x.title,
            value: x.key,
          }))}
          onChange={handleAddColumnView}
        />
      ),
      filterIcon: () => <FilterFilled style={{ color: checkedList.length > 0 ? '#1890ff' : undefined }} />,
      render: item => <ActionColumn item={item} />,
    }];
    const column = []
    column.push({
      title: 'Mã KR',
      sorter: true,
      fixed: 'left',
      width: 60,
      key: 'code',
      render: value => (
        <Space size="middle">
          <Dropdown trigger={['contextMenu']} overlay={<CustomMenu value={value} />}>
            <div className="d-flex justify-content-center align-items-center">{value.code}</div>
          </Dropdown>
        </Space>
      ),
    });
    handleColumnsBasedOnPeriodType(column);
    return [...columnDefault, ...column];
  };

  const handleAddColumnView = values => {
    setCheckedList([...values, 'action']);
  };

  const getAllEntities = (value?: string) => {
    if (filters && filters.planPeriodId) {
      const requestPayload = {
        searchText: value ?? searchText,
        page: paginationState.activePage,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        planPeriodId: filters.planPeriodId,
        objectiveId: id,
      };
      if (filters.planPeriodType === PlantPeriodType.Year) {
        dispatch(getEntitiesByYears(requestPayload));
      } else if (filters.planPeriodType === PlantPeriodType.Month) {
        dispatch(getEntitiesByMonth(requestPayload));
      } else if (filters.planPeriodType === PlantPeriodType.Quarter) {
        dispatch(getEntitiesByQuarter(requestPayload));
      }
    }
  };

  const newColumns = columnConfig.map(item => ({
    ...item,
    hidden: !checkedList.includes(item.key),
  }));

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    setPaginationState({
      ...paginationState,
      order: DESC, //sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC,
      sort: sorter.columnKey,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleFreeTextSearchQuery = query => {
    setSearchText(query);
    getAllEntities(query);
  };

  const handleCreate = () => {
    setIsOpenModalFormKr(true);
  };

  const handleWarningDeleteItem = (idSelected: number) => {
    setVisibleConfirmDelete(true);
    setIdDeletedKr(idSelected);
  };

  const handleConfirmDelete = () => {
    if (idDeletedKr) {
      dispatch(deleteEntity(idDeletedKr))
        .then(() => {
          getAllEntities();
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    }
  };

  const handleChangePlanPeriod = (planPeriodId: string) => {
    const detailPlanPeriod = _.find(planPeriodList, o => o.id === planPeriodId);
    if (detailPlanPeriod) {
      dispatch(
        setFilterKr({
          ...filters,
          planPeriodId,
          startDate: dayjs(detailPlanPeriod.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
          dueDate: dayjs(detailPlanPeriod.endDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
          planPeriodType: detailPlanPeriod.planPeriodType,
        }),
      );
    }
  };

  const handleViewResult = item => {
    setKrSelected(item);
    if (item.krType === KrTypes.Qualitative) {
      setShowModalQualitativeView(true);
    } else {
      setShowModalQuantitativeView(true);
    }
  };

  const handleCloseModalQuantitativeView = () => {
    setShowModalQuantitativeView(false);
    setKrSelected(null);
  };
  const handleCloseModalQualitativeView = () => {
    setShowModalQualitativeView(false);
    setKrSelected(null);
  };

  const handleEditKr = item => {
    setIsOpenModalFormKr(true);
    setKrSelected(item);
  };

  const handleCloseModelKr = (isReload = false) => {
    setIsOpenModalFormKr(false);
    setKrSelected(null);
    if (isReload) {
      getAllEntities();
    }
  };

  return (
    <div className="view">
      <div className="table">
        <div className="header">
          <Row className='w-100'>
            <Col md={8}>
              <Search className='w-100' size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
            </Col>
            <Col md={1} />
            <Col md={5}>
              <Select
                value={filters?.planPeriodId}
                showSearch
                className="w-100"
                options={planPeriodList.map(x => {
                  return {
                    value: x.id,
                    label: x.name,
                  };
                })}
                onChange={handleChangePlanPeriod}
                filterOption={filterOption}
                placeholder="Chọn kỳ kế hoạch"
                size="large"
              />
            </Col>
          </Row>
          <Space>
            {true /*(isAdmin || krPermissions.Add)*/ && (
              <Button
                size="large"
                onClick={() => {
                  handleCreate();
                }}
                className="primary"
                icon={<PlusOutlined />}
              >
                Thêm mới KR
              </Button>
            )}
          </Space>
        </div>
        <TableComponent
          data={krList.map((x, index) => {
            return {
              key: index + 1,
              ...x,
            };
          })}
          scroll={true}
          total={totalItems}
          isFetching={isLoading}
          tableLayout="fixed"
          columns={newColumns}
          handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
            handleChange(pageNumber, size, sorter);
          }}
        />
      </div>
      {isOpenModalFormKr && (
        <KRUpdate
          isOpen={isOpenModalFormKr}
          idKrBaseSelected={krSelected?.id}
          planPeriodIdSelected={filters?.planPeriodId}
          idObjective={id}
          planPeriodType={filters?.planPeriodType}
          krTypeRequest={krSelected?.krType}
          onClose={handleCloseModelKr}
        />
      )}
      {isShowModalQuantitativeView && (
        <ReportQuantitativeResultView
          isOpen={isShowModalQuantitativeView}
          idKrSelected={krSelected?.id}
          onClose={handleCloseModalQuantitativeView}
        />
      )}
      {isShowModalQualitativeView && (
        <ReportQualitativeResultView
          isOpen={isShowModalQualitativeView}
          idKrSelected={krSelected?.id}
          onClose={handleCloseModalQualitativeView}
        />
      )}
      <ModalConfirmComponent
        visible={visibleConfirmDelete}
        onCancel={() => {
          setVisibleConfirmDelete(false);
        }}
        onConfirm={handleConfirmDelete}
        title={`Bạn có muốn xóa KR?`}
      />
    </div>
  );
};

export default KR;
